import { toast } from 'sonner';

// Download tradicional do PDF (fallback garantido de entrega).
export const downloadPdf = (pdfBlob: Blob, fileName: string) => {
  const url = URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Entrega do PDF já gerado. A Web Share API exige transient user activation,
// que pode ter expirado durante a geração assíncrona (fetch + import dinâmico
// + render). Por isso: tentamos compartilhar e, em qualquer falha que NÃO seja
// cancelamento do usuário (AbortError), caímos para download. O usuário SEMPRE
// recebe o PDF — por share se der, por download caso contrário.
export const deliverPdf = async (pdfBlob: Blob, fileName: string) => {
  const file = new File([pdfBlob], fileName, { type: 'application/pdf' });
  const canShareFiles =
    typeof navigator !== 'undefined' &&
    !!navigator.share &&
    !!navigator.canShare &&
    navigator.canShare({ files: [file] });

  if (!canShareFiles) {
    downloadPdf(pdfBlob, fileName);
    toast.success('PDF baixado com sucesso!');
    return;
  }

  try {
    await navigator.share({ files: [file], title: fileName });
    toast.success('PDF compartilhado!');
  } catch (shareError) {
    // Cancelamento do usuário na folha de compartilhamento → não é erro.
    if (shareError instanceof DOMException && shareError.name === 'AbortError') {
      return;
    }
    // NotAllowedError (activation expirada) ou qualquer outra falha de share
    // → fallback para download, garantindo a entrega do PDF.
    downloadPdf(pdfBlob, fileName);
    toast.success('PDF baixado com sucesso!');
  }
};
